/* Vitrine Top 10 : lecture muette des vidéos visibles, son au toucher, glisser à la souris sur ordinateur. */
(() => {
  document.querySelectorAll('[data-t10]').forEach(rail => {
    const vids = [...rail.querySelectorAll('video')];
    if (vids.length && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver(es => es.forEach(e => {
        const v = e.target;
        if (e.isIntersecting && e.intersectionRatio > .6) { v.play().catch(() => {}); } else { v.pause(); }
      }), { threshold: [0, .6, 1] });
      vids.forEach(v => {
        io.observe(v);
        const b = v.closest('.t10__media')?.querySelector('[data-t10-sound]');
        if (!b) return;
        b.hidden = false;
        b.addEventListener('click', () => {
          const on = v.muted;
          vids.forEach(o => { o.muted = true; o.closest('.t10__media')?.querySelector('[data-t10-sound]')?.classList.remove('is-on'); });
          v.muted = !on; b.classList.toggle('is-on', on);
          b.setAttribute('aria-label', on ? 'Couper le son' : 'Activer le son');
          if (on) v.play().catch(() => {});
        });
      });
    }
    // Glisser à la souris
    let x0 = 0, s0 = 0, down = false, moved = false;
    rail.addEventListener('pointerdown', e => { if (e.pointerType !== 'mouse') return; down = true; moved = false; x0 = e.clientX; s0 = rail.scrollLeft; });
    window.addEventListener('pointermove', e => { if (!down) return; const dx = e.clientX - x0; if (Math.abs(dx) > 4) { moved = true; rail.classList.add('is-drag'); } rail.scrollLeft = s0 - dx; });
    window.addEventListener('pointerup', () => { if (!down) return; down = false; rail.classList.remove('is-drag'); });
    rail.addEventListener('click', e => { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
  });
})();
